// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_M3zlU","pic":"index_pic_RJYJc","txt":"index_txt_WBOER"};